export const $ = s => document.querySelector(s);
export const $$ = s => [...document.querySelectorAll(s)];
export const clamp = (v,a,b) => v<a?a:v>b?b:v;
export const lerp = (a,b,t) => a+(b-a)*t;
export const rnd = (a,b) => a + Math.random()*(b-a);
export const fmt$ = v => v>=1e9 ? '$'+(v/1e9).toFixed(2)+'B' : v>=1e6 ? '$'+(v/1e6).toFixed(1)+'M' : v>=1e3 ? '$'+(v/1e3).toFixed(0)+'K' : '$'+Math.round(v);
